import React from 'react';

import {Banner} from '@albert-io/atomic';

export default function ReviewAnswersInEnglishBanner({className}: PropsWithClassNameOptional) {
  return (
    <Banner className={className} type='warning'>
      Se le califica según el texto en inglés; revise sus respuestas en inglés.
    </Banner>
  );
}
